/**
 * Generates an array of investment option objects with `value` and `label` properties,
 * based on the investments present in the provided state object.
 *
 * Each investment option is included only if it has both a `name` and a `type`.
 * The `label` and `value` are constructed by concatenating the trimmed `name` and `type`
 * with a hyphen separator.
 *
 * @param {Object} state - The state object containing an `investments` array.
 * @param {Array<Object>} [state.investments] - The array of investment objects.
 * @param {string} state.investments[].name - The name of the investment.
 * @param {string} state.investments[].type - The type of the investment.
 * @returns {Array<{ value: string, label: string }>} The formatted investment options.
 */
const getInvestmentOptions = (state) => {
  const investmentOptions = (state.investments || [])
    .filter((i) => i.name && i.type)
    .map((i) => {
      const label = `${i.name.trim()} - ${i.type.trim()}`;
      return { value: label, label };
    });

  return investmentOptions;
};

export default getInvestmentOptions;
